import { CallResult, doApiGet, doApiPatch } from "./Requests";

export const translationsApi = {
    getTranslations: async (
        entityType: string,
        entityId: string,
        property: string
    ): Promise<CallResult<Record<string, string>>> => {
        return await doApiGet<Record<string, string>>(
            `/api/companies/current/translations/${entityType}/${entityId}/${property}`
        );
    },

    patchTranslations: (
        entityType: string,
        entityId: string,
        property: string,
        translations: Record<string, string>,
        nestedId?: string[]
    ) => {
        const query = nestedId ? `?nestedId=${nestedId.join(",")}` : "";
        return doApiPatch<Record<string, string>, unknown>(
            `/api/companies/current/translations/${entityType}/${entityId}/${property}${query}`,
            translations
        );
    },

    updateUserLanguage: (languageTag: string) =>
        doApiPatch(`/api/users/current/localization/language`, languageTag),
};
